export const namespaces = [
  'sendInvite',
  'common',
  'validation',
  'page',
  'page2',
  'inviteListing',
  'userSettings',
  'manageInvite',
  'profile',
  'templates',
  'contactListing',
  'userListing',
  'integrations',
  'indicators',
  'customDomain',
  'socialLogin',
  'followUp',
  'contacts',
  'contactGroup',
  'sso',
  'mfa',
  'workspaces',
  'permissions',
  'sentryErrorModal',
  'dataRetention',
];
